import React from "react";
import styled from "styled-components";

import { FlexContainer, FlexDiv } from "@/components/Atoms/Box";
import Button from "@/components/Atoms/Button";

import theme from "@/foundation/Theme";
import Typography from "@/foundation/Typography/V2";

function BannerSection(props) {
  const { yogaDetailsData, handleScrollToSection = () => {} } = props || {};

  const h1 = yogaDetailsData?.og_meta?.h1_title;

  return (
    <Wrapper
      title="Yoga - Shyft"
      banner={yogaDetailsData?.hero?.hero_background}
      bannerMobile={yogaDetailsData?.hero?.hero_background_mob}
    >
      <FlexContainer
        flexDirection="column"
        justifyContent="center"
        position="relative"
        zIndex="1"
      >
        <WrapperDiv>
          {/* <Typography
            fontFamily={"var(--font-600)"}
            variant={"paragraph1"}
            color={theme.colors.white}
          >
            {yogaDetailsData?.hero?.hero_title_first_line}
          </Typography> */}
          {h1 && <h1 className="seo-heading-1">{h1}</h1>}
          <Heading
            variant={h1 ? "heading2" : "heading1"}
            fontSize={["24px", "30px", "30px"]}
            color={theme.colors.white}
            lineHeight={"normal"}
          >
            {yogaDetailsData?.hero?.hero_title}
          </Heading>
          {yogaDetailsData?.hero?.hero_subtitle && (
            <FlexDiv>
              <Btn
                mt={"25px"}
                variant={"primary1"}
                bgColor={theme.colors.yellow}
                hoverColor={`${theme.colors.yellow}eb`}
                fontFamily={"var(--font-700)"}
                fontSize={"18px"}
                onClick={false ? () => handleScrollToSection : () => {}}
              >
                {yogaDetailsData?.hero?.hero_subtitle}
              </Btn>
            </FlexDiv>
          )}
        </WrapperDiv>
      </FlexContainer>
    </Wrapper>
  );
}

export default BannerSection;
const Wrapper = styled(FlexDiv)`
  background: url("${({ banner }) => banner}") center no-repeat;
  background-size: cover;
  position: relative;
  padding: 50px 0;
  min-height: 200px;
  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-image: ${theme.colors.linearGradBlue};
  }
  @media only screen and (max-width: 767px) {
    background: url("${({ bannerMobile }) => bannerMobile}") center no-repeat;
    background-position-y: top;
    background-size: 100%;
    padding: 25px 0;
  }
  @media only screen and (max-width: 349px) {
    background-size: cover;
  }
`;
const WrapperDiv = styled(FlexDiv)`
  flex-direction: column;
  @media only screen and (max-width: 767px) {
    align-items: center;
    text-align: center;
  }
`;
const Btn = styled(Button)`
  cursor: default !important;
  @media only screen and (max-width: 1159px) {
    font-size: 15px;
  }
`;
export const StrikeThrough = styled.del`
  font-family: inherit;
  color: inherit;
  line-height: inherit;
  font-size: inherit;
`;
const Heading = styled(Typography)`
  @media only screen and (max-width: 767px) {
    max-width: 275px;
    margin: 0 auto;
  }
`;
